<template>
  <el-autocomplete class="inline-input" v-model="tjkName" :fetch-suggestions="querySearchAsync" placeholder="请输入姓名或淘金号" @select="handleSelect" :trigger-on-focus="false" :debounce="500"></el-autocomplete>
</template>
<script>
  export default {
    name: 'tjkautocomplete',
    data() {
      return {
        tjkName: ''
      }
    },
    watch: {
      tjkName: function() {
        if(this.tjkName == '') {
          this.$emit('callBack', '')
        }
      }
    },
    methods: {
      //根据姓名或登录账户查询淘金客信息
      querySearchAsync(queryString, callback) {
        if((queryString !== '') && (queryString.length >= 2)) {
          var list = []
          var data = {
            'tjkParam': queryString
          }
          this.$http.post(API_ROOT.tjkuser + '/tjk/query', data).then(response => {
            var result = response.data
            if(result.success) {
              this.success = result.success
              this.message = result.msg
              //在这里为这个数组中每一个对象加一个value字段, 因为autocomplete只识别value字段并在下拉列中显示  
              for(let i of response.data.data) {
                i.value = i.realName + '（' + i.tjkNumber + '）'
              }
              list = result.data
              callback(list)
            }else {
              alert(result.msg)
            }
          }, response => {
            alert('网络繁忙，请稍后重试！')
          })
        }
      },
      handleSelect(item) {
        this.$emit('callBack', item.id)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// ./src/components/tjkAutoComplete.vue